/** Encode each path segment so spaces and special chars work in img/CSS URLs. */
function encodeAssetPath(path) {
  return path
    .split("/")
    .filter((seg) => seg.length > 0)
    .map((seg) => encodeURIComponent(seg))
    .join("/");
}

/**
 * Build absolute URL for theme assets (S3 base + path, or pass through http(s) URLs).
 */
export function buildThemeAssetUrl(asset) {
  if (asset == null) return "";
  const s = typeof asset === "string" ? asset.trim() : "";
  if (!s) return "";
  if (/^https?:\/\//i.test(s)) return s;
  const base = (process.env.REACT_APP_S3_PATH || "").replace(/\/+$/, "");
  const path = encodeAssetPath(s.replace(/^\/+/, ""));
  if (!base) return path ? `/${path}` : "";
  return `${base}/${path}`;
}

/**
 * Theme page background: mobile (≤768px) prefers background_mob, else background_desk, then mob fallback.
 */
export function themeBackgroundImageUrl(themeData) {
  if (!themeData) return "";
  const w = typeof window !== "undefined" ? window.innerWidth : 1024;
  const isMobile = w <= 768;
  const raw =
    isMobile && themeData.background_mob
      ? themeData.background_mob
      : themeData.background_desk || themeData.background_mob || "";
  return buildThemeAssetUrl(raw);
}
